initAccordions();

function initAccordions() {
  const accordionsContainers = document.querySelectorAll(
    ".accordion_container"
  );
  const accordions = document.querySelectorAll(".accordion_button");
  accordionsContainers.forEach((accordionContainer) => {
    const accordionBtn = accordionContainer.querySelector(".accordion_button");
    const accordionContent = accordionContainer.querySelector(
      ".accordion__content"
    );
    accordionContent.style.height = accordionContent.scrollHeight + "px";
    
    accordionBtn?.addEventListener("click", function () {
      this.classList.toggle("active");

      const content = this.nextElementSibling;
      if (accordionContent.classList.contains("open")) {
        accordionContent.classList.remove("open");
        accordionContent.classList.add("closed");
      } else {
        accordionContent.classList.remove("closed");
        accordionContent.classList.add("open");
        accordionContent.style.height = accordionContent.scrollHeight + "px";
      }
    });
  });
}
const productAccorodions = document.querySelectorAll(
  ".product__info-container .accordion_container"
);

productAccorodions.forEach((accordionContainer) => {
  const accordionBtn = accordionContainer.querySelector(".accordion_button");
  accordionBtn?.addEventListener("click", function () {
    productAccorodions.forEach((element) => {
      const accordionContent = element.querySelector(".accordion__content");
      if (element != accordionContainer) {
        if (accordionContent.classList.contains("open")) {
          element.querySelector(".accordion_button").classList.toggle("active");
          accordionContent.classList.remove("open");
          accordionContent.classList.add("closed");
        }
      }
    });
  });
});

const howtouseAccorodions = document.querySelectorAll(
  ".usage-sectoin .accordion_container"
);

howtouseAccorodions.forEach((accordionContainer) => {
  const accordionBtn = accordionContainer.querySelector(".accordion_button");
  accordionBtn.addEventListener("click", function () {
    howtouseAccorodions.forEach((element) => {
      const accordionContent = element.querySelector(".accordion__content");
      if (element != accordionContainer) {
        if (accordionContent.classList.contains("open")) {
          element.querySelector(".accordion_button").classList.toggle("active");
          accordionContent.classList.remove("open");
          accordionContent.classList.add("closed");
        }
      }
    });
  });
});
